import ClipBoard from 'clipboard';
import React, {Component} from 'react';
import PropTypes from 'prop-types'

export class ClipboardText extends Component {
    componentDidMount() {
        const button = this.button;
        const input = this.input;


        this.clipboard = new ClipBoard(
            button, {
                target: () => input
            }
        )
    }

    componentWillUnmount() {
        this.clipboard.destroy()
    }

    render() {
        const {
            value
        } = this.props;

        return (
            <p>
                <span
                    ref={(element) => {
                        this.input = element
                    }}
                > {value}</span>&nbsp;
                <button ref={(element) => {
                    this.button = element
                }} className="ui tiny compact icon button"><i aria-hidden="true" className="clipboard icon"></i>
                </button>


            </p>
        )
    }
}

ClipboardText.propTypes = {
    value: PropTypes.string.isRequired
};

